var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 132,
    viewBox: "0 0 119 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 119,
    height: 132,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_305_489",
    transform: "scale(0.00840336 0.00757576)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_305_489",
    width: 119,
    height: 132,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAACECAYAAACqP7Q9AAABjElEQVR4Ae3ZsQ2AMBADwN9/pQwHokubwkXMIdFBBGf4wpm11vOdc3C4Z+YKgyse0ocX//kOiF1KgAABAgQIECBAgAABAgQIECBAgACBOwrwg5x05dumBowN48cf0cGru5QAAQIECBAgQIAAAQIECBAgQIAAAQI2Dqa4W7ZxUByu4UWAAAECBAgQIECAAAECBAgQIECAAIGQgG65uFsWbnG4oYFgWQIECBAgQIAAAQIECBAgQIAAAQIECOiWi7tl4RaHa3YRIECAAAECBAgQIECAAAECBAgQIEAgJKBbLu6WhVscbmggWJYAAQIECBAgQIAAAQIECBAgQIAAAQK65eJuWbjF4ZpdBAgQIECAAAECBAgQIECAAAECBAgQCAnolou7ZeEWhxsaCJYlQIAAAQIECBAgQIAAAQIECBAgQICAbrm4WxZucbhmFwECBAgQIECAAAECBAgQIECAAAECBEICuuXiblm4xeGGBoJlCRAgQIAAAQIECBAgQIAAAQIECBAgoFsu7paF2xvuC2PieszGdZDJAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.34fb11e6c66a8271035d88cab27504f9.svg";
export { ForwardRef as ReactComponent };